import paronApi from '@/utils/paron-api'
export default {
    getAllTransactions() {
        return paronApi.get('transaction/all')
    },

    getTransactionById(id) {
        return paronApi.get(`transaction/${id}`)
    },

    createTransaction(data) {
        return paronApi.post('transaction/new', data)
    },

    editTransactionById(id, data) {
        return paronApi.post(`transaction/${id}/edit`, data)
    },

    deleteTransactionById(id) {
        return paronApi.delete(`transaction/${id}`)
    },
    getTransactionsByFilter(page, filter, perPage = 10) {
        return paronApi.post(`transaction/filtered?page=${page || 1}&per_page=${perPage}`, filter)
    },
    exportTransactionsByFilter(filter) {
        return paronApi.download('transaction/export', filter)
    }

}
